import { render } from "./InnovationLab.vue?vue&type=template&id=5f9aadc7"
import script from "./InnovationLab.vue?vue&type=script&lang=js"
export * from "./InnovationLab.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__